import { useQuery } from '@apollo/client/react';

import type {
  GetProfileAvatarQuery,
  GetProfileAvatarQueryVariables,
} from 'src/__generated__/graphql';
import { GET_PROFILE_AVATAR } from 'src/modules/graphql-client/queries/profile-avatar.graphql';

export const useGetProfileAvatar = () => {
  const { data, loading } = useQuery<
    GetProfileAvatarQuery,
    GetProfileAvatarQueryVariables
  >(GET_PROFILE_AVATAR);

  const rawProfileAvatar = data?.viewer?.profileAvatar;

  // Transform null to undefined for component compatibility
  const profileAvatar = rawProfileAvatar
    ? {
        id: rawProfileAvatar.id,
        image128Url: rawProfileAvatar.image128Url ?? undefined,
      }
    : undefined;

  return { profileAvatar, loading };
};
